/*
 *   Copyright (c) 2022 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import { ProcessQResponseMessage } from "../../../messages";
import { StorageModule } from "@vlinder-web/storage-module-react";

export const updateCurrentQueueStore = async (context: any, event: any) => {
  return new Promise(async (resolve, reject) => {
    const message: ProcessQResponseMessage = context?.message;
    try {
      const storageService = StorageModule.getInstance();
      storageService.set(
        "io.vlinder.activeQStore",
        message?.raw?.parsed,
        "memory"
      );
      return resolve(true);
    } catch (err: any) {
      console.log(`error in formatQueueHeaderData error=${err?.message}`);
      return reject(err?.message);
    }
  });
};
